import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { GtmAnalyticsEvent, GtmEventType } from './gtmEventType';

interface GtmCustomExperimentEvent extends GtmAnalyticsEvent {
    experimentId: string;
    variantId: number;
}

export class GtmCustomExperimentType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.EXPERIMENT_IMPRESSION;
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GtmCustomExperimentEvent {
        return {
            event: AnalyticsEventTopic.EXPERIMENT_IMPRESSION,
            timestamp: event.timestamp,
            eventContext: 'unknown',
            experimentId: event.experimentId,
            variantId: event.variantId,
        };
    }
}
